/* import __COLOCATED_TEMPLATE__ from './submenu-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();